import { paths } from "src/routes/paths";

import { safeReturnTo } from "./safe-return-to";

type LoginLocation = Pick<
  Location,
  "href" | "pathname" | "search" | "hash" | "reload" | "replace"
>;

export function completeDialogLogin({
  startedHref,
  returnTo,
  onClose,
  location = window.location,
}: {
  startedHref: string;
  returnTo?: string;
  onClose: () => void;
  location?: LoginLocation;
}) {
  onClose();

  // A caller's navigation takes precedence. LoginPage owns /login navigation.
  if (
    location.href !== startedHref ||
    new URL(startedHref).pathname === paths.auth.jwt.login
  ) {
    return;
  }

  const currentPath = `${location.pathname}${location.search}${location.hash}`;
  const target = returnTo ? safeReturnTo(returnTo) : currentPath;

  if (target === currentPath) {
    location.reload();
  } else {
    location.replace(target);
  }
}
